import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { ChatBotPage } from '../pages/ChatBotPage';

export const getChatBotInternalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    chatBot: {
      path: `${basePath}/chatbot`,
      url: `${baseUrl}/chatbot`,
      documentTitle: 'AI Assistant',
    },
  };
};

export const getChatBotInternalRoutes = (
  basePath: string,
  baseUrl: string
) => {
  const config = getChatBotInternalRoutesConfig(basePath, baseUrl);

  return {
    chatBot: (
      <Route exact path={config.chatBot.path}>
        <Page routeDefinition={config.chatBot}>
          <ChatBotPage />
        </Page>
      </Route>
    ),
  };
};
